import { render, staticRenderFns } from "./NewWarningBox.vue?vue&type=template&id=891ee8b6&scoped=true"
import script from "./NewWarningBox.vue?vue&type=script&lang=js"
export * from "./NewWarningBox.vue?vue&type=script&lang=js"
import style0 from "./NewWarningBox.vue?vue&type=style&index=0&id=891ee8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891ee8b6",
  null
  
)

export default component.exports